import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Layers, Target, Building2 } from 'lucide-react';
export function PlatformStructure() {
  const cards = [{
    icon: <Activity size={24} data-id="element-511" />,
    title: 'CJI Core',
    desc: "The Civic Judgment Index is the platform's analytical foundation. It focuses on reasoning quality, decision competence, propaganda resistance, manipulation vulnerability, and leadership diagnostics.",
    color: 'text-navy'
  }, {
    icon: <Layers size={24} data-id="element-512" />,
    title: 'NCJI Framework',
    desc: 'The Neurocognitive Civic Judgment Index expands the system into a fuller developmental and institutional architecture spanning opportunity guidance, lifecycle development, public-sector readiness, and executive governance evaluation.',
    color: 'text-teal'
  }, {
    icon: <Target size={24} data-id="element-513" />,
    title: 'Guidance and Development Layer',
    desc: 'Every meaningful weakness identified should be paired with a pathway. Every barrier should be translated into a plan. Every plan should connect to some combination of self-directed tools, institutional support, educational pathways, community reinforcement, or public-sector infrastructure.',
    color: 'text-green-soft'
  }, {
    icon: <Building2 size={24} data-id="element-514" />,
    title: 'Institutional and Strategic Layer',
    desc: 'At scale, the platform supports schools, employers, civil society organizations, public institutions, and governments through aggregate capability mapping, readiness tracking, leadership-pipeline analysis, and strategic planning.',
    color: 'text-navy-light'
  }];
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-515">
      <div className="mb-16" data-id="element-516">
        <span className="text-xs font-semibold text-navy-light uppercase tracking-[0.2em] mb-4 block" data-id="element-517">
          Platform Structure
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark" data-id="element-518">
          The architecture behind CJI and NCJI
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-519">
        {cards.map((card, index) => <motion.div key={card.title} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="bg-surface-card p-8 lg:p-10 rounded-lg border border-line shadow-sm hover:shadow-md transition-shadow" data-id="element-520">
            <div className={`w-12 h-12 rounded-md bg-surface-muted flex items-center justify-center mb-6 border border-line ${card.color}`} data-id="element-521">
              {card.icon}
            </div>
            <h3 className="text-2xl font-heading font-bold text-ink-dark mb-4" data-id="element-522">
              {card.title}
            </h3>
            <p className="text-ink-muted leading-relaxed text-lg" data-id="element-523">
              {card.desc}
            </p>
          </motion.div>)}
      </div>
    </section>;
}